console.log("🚀 Quick Buy JS Loaded - Waiting for modals to open");

// Wait for the DOM to fully load
document.addEventListener("DOMContentLoaded", onDomReady, { passive: true });

function onDomReady() {
  console.log("✅ DOM Fully Loaded, attaching modal event listener");

  document.body.addEventListener("click", onVariantSwatchClick, { passive: false });
}

function onVariantSwatchClick(event) {
  // Bail early if click is not on a swatch
  const swatch = event.target.closest("[data-variant-swatch]");
  if (!swatch) return;
  console.log(event.target.getAttribute("context"))

  if(event.target.getAttribute("context") != "main_product" && event.target.getAttribute("context") != "variant-swatch" ) {
    event.preventDefault(); // Cancel default <a> navigation
    const modal = swatch.closest(".quick-buy-modal__content");
    if (modal) {
      handleSwatchClick(event, swatch, modal);
    }
  }
}


let isFetching = false;

function handleSwatchClick(event, element) {
    if (isFetching) return;
    isFetching = true;
    event.preventDefault(); // Prevent PDP navigation

    const productUrl = element.getAttribute('href');
    const newHandle = productUrl.split('/products/')[1].split('/')[0];
    const modalComponent = document.querySelector('quick-buy-modal[open]');

    if (!modalComponent) return;

    // ✅ NEW PRODUCT: Fetch and replace modal content
   fetch(`/products/${newHandle}`)
    .then(res => res.text())
    .then(html => {
        const wrapper = document.createElement('div');
        wrapper.innerHTML = html
        const template = wrapper.querySelector('#quick-buy-content');

        if (!template || !template.content) {
            console.error("❌ <template id='quick-buy-content'> not found");
            return;
        }

      const contentFragment = template.content.cloneNode(true);

        // Only remove <noscript> if any exist
        const noscripts = contentFragment.querySelectorAll("noscript");
        if (noscripts.length > 0) {
        for (const n of noscripts) {
            n.remove();
        }
        }

        // Remove only necessary children from modalComponent
        for (let i = modalComponent.children.length - 1; i >= 0; i--) {
        const child = modalComponent.children[i];
        if (child.slot === 'header' || child.classList.contains('quick-buy-modal__content')) {
            modalComponent.removeChild(child);
        }
        }


        // Inject new content (slotted automatically)
        modalComponent.appendChild(contentFragment);
 
  
    })
    .catch(err => {
        console.error('Failed to load new quick shop:', err);
    })
    .finally(() => {
    isFetching = false;
    });
}
